import { useState, useEffect, useRef } from "react";

import { Autocomplete, TextField } from "@mui/material";

import { industries } from "../../config/profileIndustries";
import { useLocalizedTranslation } from "../../hooks/useLocalizedTranslation";

const IndustrySelect = ({
  name = "industry",
  placeholder = "",
  value = "",
  onChange = () => {},
  language = null,
}) => {
  const { t: translation } = useLocalizedTranslation(
    language,
    "components/industrySelect"
  );

  const [inputValue, setInputValue] = useState(value || "");
  const didSelectFromOptions = useRef(false);

  const localizedIndustries = industries.map((industry) => ({
    label: translation(industry),
    value: industry,
  }));

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleBlur = () => {
    if (!didSelectFromOptions.current && inputValue !== value) {
      onChange({ target: { name, value: inputValue } });
    }
    didSelectFromOptions.current = false;
  };

  return (
    <Autocomplete
      freeSolo
      options={localizedIndustries}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option.label
      }
      value={localizedIndustries.find((opt) => opt.value === value) || value}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      onChange={(event, newValue) => {
        let selectedValue;
        if (typeof newValue === "string") {
          selectedValue = newValue;
        } else if (newValue?.value) {
          selectedValue = newValue.value;
        } else {
          selectedValue = "";
        }

        didSelectFromOptions.current = true;
        onChange({ target: { name, value: selectedValue } });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          onBlur={handleBlur}
          placeholder={placeholder}
        />
      )}
    />
  );
};

export default IndustrySelect;
